module.exports = __webpack_public_path__ + "img/heart.cf15c01f.png";